import { render, staticRenderFns } from "./InventoryEditAdmin.vue?vue&type=template&id=70635428&scoped=true"
import script from "./InventoryEditAdmin.vue?vue&type=script&lang=js"
export * from "./InventoryEditAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70635428",
  null
  
)

export default component.exports